import React from "react";
import { Typography, Box, Container } from "@mui/material";
import { useTranslation } from "react-i18next";
import logo from "../assets/5bc.png";

const AboutCurrency: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <img src={logo} alt="Logo" style={{ height: 48, marginRight: 16 }} />
        <Typography variant="h5">{t("news.title")}</Typography>
      </Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {t("news.about_title")}
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        {t("news.about_desc")}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t("news.about_footer")}
      </Typography>
    </Container>
  );
};

export default AboutCurrency;
